var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"card-tag",class:_vm.tagType},[_vm._v(_vm._s(_vm.tagValue))])}
var staticRenderFns = []

export { render, staticRenderFns }